import type { AnyTranslationKey } from '@/shared/i18n';
import type { RoleName, UserStatus } from './admin.schema';

export const USER_STATUSES: UserStatus[] = ['active', 'suspended', 'deactivated'];

export const ADMIN_ROLES: RoleName[] = ['manager', 'operator', 'monitor'];

export const ROLE_PERMISSIONS: {
  id: string;
  labelKey: AnyTranslationKey;
  granted: Record<RoleName, boolean>;
}[] = [
  {
    id: 'manage-users',
    labelKey: 'userManagement:roleAccessMatrix.permissions.manageUsers',
    granted: { admin: true, manager: true, operator: false, monitor: false },
  },
  {
    id: 'manage-roles',
    labelKey: 'userManagement:roleAccessMatrix.permissions.assignRoles',
    granted: { admin: true, manager: true, operator: false, monitor: false },
  },
  {
    id: 'view-audit',
    labelKey: 'userManagement:roleAccessMatrix.permissions.viewAuditLogs',
    granted: { admin: true, manager: true, operator: false, monitor: false },
  },
  {
    id: 'manage-devices',
    labelKey: 'userManagement:roleAccessMatrix.permissions.manageDevices',
    granted: { admin: true, manager: true, operator: true, monitor: false },
  },
  {
    id: 'view-alerts',
    labelKey: 'userManagement:roleAccessMatrix.permissions.viewState',
    granted: { admin: true, manager: true, operator: true, monitor: true },
  },
  {
    id: 'view-alerts',
    labelKey: 'userManagement:roleAccessMatrix.permissions.viewAlerts',
    granted: { admin: true, manager: true, operator: true, monitor: true },
  },
];

export const USER_STATUS_COLOR: Record<UserStatus, string> = {
  active: 'bg-success-tint text-success',
  suspended: 'bg-warning-tint text-warning',
  deactivated: 'bg-neutral-tint text-ink-muted',
};
